import { useQuery } from "@tanstack/react-query";

import { FETCH_ERROR } from "../consts/fetch-error";
import { getLease, getLeases } from "../services/lease";

export function useGetLeases() {
  return useQuery({
    queryKey: ["leases"],
    queryFn: () => getLeases(),
    staleTime: 1000 * 60 * 60, // 1 hour
    retry: (_failureCount, error: unknown) =>
      error !== FETCH_ERROR.UNAUTHORIZED,
  });
}

export function useGetLease(id: string) {
  return useQuery({
    queryKey: ["lease", id],
    queryFn: () => getLease(id),
    retry: (_failureCount, error: unknown) =>
      error !== FETCH_ERROR.UNAUTHORIZED,
  });
}
